import type { TextContent } from '../block-content';
import { validateTextContent } from '../block-content';

import type {
  BlockComponent,
  BlockComponentTypeValue,
} from './block-component';
import {
  AlignStyle,
  BlockComponentType,
  SizeStyle,
  validateBlockComponent,
} from './block-component';

const VALID_ALIGN_STYLES = [AlignStyle.Left, AlignStyle.Center] as const;
const VALID_SIZE_STYLES = [SizeStyle.Default, SizeStyle.Small] as const;

type ValidAlignStyle = (typeof VALID_ALIGN_STYLES)[number];
type ValidSizeStyle = (typeof VALID_SIZE_STYLES)[number];

export interface TextDoubleBlockComponent extends BlockComponent {
  readonly type: BlockComponentTypeValue<'TextDouble'>;
  readonly align: ValidAlignStyle;
  readonly size: ValidSizeStyle;

  readonly title: TextContent;
  readonly subText: TextContent;
}

export function validateTextDoubleBlockComponent(
  param: unknown
): param is TextDoubleBlockComponent {
  return (
    // is block component
    validateBlockComponent(param) &&
    param.type === BlockComponentType.TextDouble &&
    VALID_ALIGN_STYLES.includes(param.align as ValidAlignStyle) &&
    VALID_SIZE_STYLES.includes(param.size as ValidSizeStyle) &&
    // has title
    'title' in param &&
    validateTextContent(param.title) &&
    // has subText
    'subText' in param &&
    validateTextContent(param.subText)
  );
}
